import styled from 'styled-components';
import { Palette } from 'config';
import { Link } from 'react-router-dom';

export const StatusWrapp = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  svg {
    fill: ${() => Palette.PrimaryGray._400};
    width: 16px;
    height: 16px;
  }

  span {
    color: ${() => Palette.PrimaryGray._700};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const MyLink = styled(Link)`
  text-decoration: none;
  color: ${() => Palette.Primary._500};
  cursor: pointer;
  margin-left: 3px;
`;

export const MyA = styled(MyLink).attrs({ as: 'a' })``;

export const Box = styled.span`
  color: ${() => Palette.Primary._500}!important;
  cursor: pointer;
  margin-left: 3px;
`;

export const AwaitingStatusWrap = styled.span`
  color: ${Palette.Red._500}!important;
  margin-right: 3px;
`;
